/**
 * A trigger group from the management line. Lighter, faster, and never issued below floor nine.
 */

import type { Affix } from '@/sim/items/affixContract';

export const EXECUTIVE_TRIGGER = {
  id: 'executiveTrigger',
  slot: 'prefix',
  field: 'fireRate',
  direction: 1,
  label: 'Increased fire rate',
  nameWord: 'Executive',
  ranges: {
    common: { min: 0.03, max: 0.07 },
    uncommon: { min: 0.07, max: 0.12 },
    rare: { min: 0.12, max: 0.18 },
    exotic: { min: 0.18, max: 0.26 },
  },
} as const satisfies Affix;
